module.exports = __webpack_public_path__ + "img/calendar.39793bc7.svg";